<template>
  <div
    class="modal fade ag-modal ag-scope-modal"
    id="logoutModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Session Expiring Soon</h3>
        </div>

        <div class="">
          <div class="container">
            <div class="row d-flex justify-content-start">
              <div class="col-2 m-0 p-0">
                <div class="d-flex swal2-icon swal2-warning swal2-icon-show">
                  <div class="swal2-icon-content">!</div>
                </div>
              </div>
              <div
                class="col-6 d-flex align-items-center justify-content-center"
              >
                <p>
                  Your session will expire due to inactivity and you will need
                  to log in again for security reasons.
                </p>
              </div>
              <div
                class="col-3 d-flex flex-column align-items-center justify-content-center p-0"
              >
                <span>Remaining Time</span>
                <h1>{{ minutes }}:{{ seconds }}</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
            data-dismiss="modal"
            @click="logOutNow"
          >
            Log out Now
          </button>
          <button
            type="button"
            class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary"
            data-dismiss="modal"
            @click="stayConnected"
          >
            Stay Connected
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
/* eslint-disable */
import { mapState, mapActions, mapGetters } from "vuex";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { useStore } from "@/store";

const store = useStore();

export default {
  props: {
    opened: Boolean,
  },
  name: "ag-logout-modal",
  data() {
    return {
      logoutTime: null,
      minutes: null,
      seconds: null,
      timeOut: null,
    };
  },
  computed: {
    ...mapGetters(["loggedInUser"]),
  },
  watch: {
    opened(newValue, oldValue) {
      if(newValue) {
        this.logout();
      }
    },
  },
  methods: {
    logout() {
      const startingMinutes = 0.5;
      let time = startingMinutes * 60;
      const updateCountDown = () => {
        const minutes = Math.floor(time / 60);
        let seconds = time % 60;
        seconds = seconds < 1 ? "0" + seconds : seconds;
        time--;
        this.logoutTime = time;
        this.minutes = minutes;
        this.seconds = seconds;
        if (this.logoutTime < 0) {
          this.logOutNow();
        } else {
          this.timeOut = setTimeout(updateCountDown, 1000);
        }
      };
      updateCountDown();
    },
    logOutNow() {
      this.stayConnected();
      localStorage.clear();
      sessionStorage.clear();
      location.href = "/bff/logout?sid=" + this.loggedInUser.sid;
    },
    stayConnected() {
      this.logoutTime = null;
      this.minutes = null;
      this.seconds = null;
      clearTimeout(this.timeOut);
      this.timeOut = null;
      store.commit(GeneralActionTypes.SET_ISCREATED_MODAL, false);
    },
  },
};
</script>
  
<style lang="scss" scoped>
ul,
li,
label {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
*,
*::before,
*::after {
  box-sizing: content-box;
}
.tree {
  margin: 3.5em;
  font-size: 20px !important;
}
.tree * {
  font-size: 20px !important;
}

.tree input {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.tree input ~ ul {
  display: none;
}

.tree input:checked ~ ul {
  display: block;
}

/* ————————————————————–
    Tree rows
  */
.tree li {
  line-height: 1.2;
  position: relative;
  padding: 0 0 1em 1em;
}

.tree ul li {
  padding: 1em 0 0 1em;
}

.tree > li:last-child {
  padding-bottom: 0;
}

/* ————————————————————–
    Tree labels
  */
.tree_label {
  position: relative;
  display: inline-block;
  letter-spacing: 0px;
  color: #4c8dbb;
}

.not-found {
  color: #fa4443;
  font-size: 16px !important;
  text-align: center;
  margin: 0 auto;
  display: flex;
  align-items: center;
  width: 100%;
  display: block;
}

label.tree_label {
  cursor: pointer;
}

label.tree_label:hover {
  color: #666;
}

/* ————————————————————–
    Tree expanded icon
  */
label.tree_label:before {
  background: #4c8dbb;
  color: #fff;
  position: relative;
  z-index: 1;
  float: left;
  margin: 0 1em 0 -2em;
  width: 1em;
  height: 1em;
  border-radius: 1em;
  content: "+";
  text-align: center;
  line-height: 0.9em;
}

:checked ~ label.tree_label:before {
  content: "-";
}

/* ————————————————————–
    Tree branches
  */
.tree li:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -0.5em;
  display: block;
  width: 0;
  border-left: 2px solid #d6dfe1;
  content: "";
}

.tree_label:after {
  position: absolute;
  top: 0;
  left: -1.5em;
  display: block;
  height: 0.5em;
  width: 1em;
  border-bottom: 2px solid #d6dfe1;
  border-left: 2px solid #d6dfe1;
  border-radius: 0 0 0 0.3em;
  content: "";
}

label.tree_label:after {
  border-bottom: 0;
}

:checked ~ label.tree_label:after {
  border-radius: 0 0.3em 0 0;
  border-top: 2px solid #d6dfe1;
  border-right: 2px solid #d6dfe1;
  border-bottom: 0;
  border-left: 0;
  bottom: 0;
  top: 0.5em;
  height: auto;
}

.tree li:last-child:before {
  height: 1em;
  bottom: auto;
}

.tree > li:last-child:before {
  display: none;
}

.tree_custom {
  display: block;
  background: #eee;
  padding: 1em;
  border-radius: 0.3em;
}

//////////
.policy__wrapper {
  padding-bottom: 36px;
  background-color: #fafafa;
  overflow: hidden;
  position: inherit;
}

.policy:first-child:before {
  width: 0px !important;
}

.company-admin {
  .policy__body__wrapper {
    margin-top: 2px;
  }

  .policy:first-child::before {
    width: 0px !important;
  }
}

.header-select-global {
  margin-top: 24px;
  padding: 24px;
  margin-bottom: -50px;
  &:after {
    content: "";
    height: 200vh;
    background: #d7dfe2;
    width: 2px;
    display: block;
    margin-left: 55px;
    margin-top: -14px;
    position: absolute;
    border-style: solid;
    border-width: 0 0 2px 2px;
    position: relative;
    /* float: right; */
    clear: none;
    /* right: -3px; */
    /* top: -3px; */
    background-color: transparent;
    width: 25px;
    height: 56px;
    position: absolute;
    border-color: #d8dfe3;
    z-index: 9;
  }
}

.header-select {
  margin-top: 24px;
  padding: 24px;
  margin-bottom: -50px;

  &:after {
    content: "";
    height: 200vh;
    background: #d7dfe2;
    width: 2px;
    display: block;
    margin-left: 55px;
    margin-top: -12px;
    position: absolute;
  }
}

.scope-tree {
  .policy {
    &.has-header {
      padding: 2px;
      position: relative;
      margin-left: 111px;
      margin-top: 20px;
      margin-bottom: -20px;
    }
    .policy__header {
      border: none !important;
      text-align: left;

      &:before {
        content: "";
        height: 2px;
        background: #d7dfe2;
        width: 40px;
        display: block;
        margin-left: -34px;
        margin-top: 10px;
        position: absolute;
      }

      .policy__header__title {
        text-align: left;
        margin-left: 12px;
      }
    }
  }
}

.policy {
  background-color: #fafafa;
  padding: 24px;
  position: relative;

  &.has-header {
    padding: 24px;
    position: relative;
    margin-left: 90px;
    margin-top: 20px;

    &:before {
      content: "";
      background: #d8dfe3;
      width: 0px !important;
    }
  }

  &:before {
    content: "";
    background: #d8dfe3;
    width: 2px;
    height: calc(100% - 45px);
    margin-left: 28px;
    position: absolute;
    top: 71px;
  }

  &__header:first-child {
    width: auto;
    min-width: 120px;
    display: inline-block;
    text-align: center;
    margin-bottom: 12px;
  }

  &__header {
    display: flex;
    background-color: #fafafa;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #4c8dbb;
    border: solid #d8dfe3;
    border-width: 0px 0 2px 0;
    align-items: center;
    cursor: pointer;
    padding: 12px 0;

    &__arrow {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      transition: 0.5s cubic-bezier(0, 1, 0, 1);

      border: 1px solid #4c8dbb;
      padding: 3px;
      color: #4c8dbb;
      cursor: pointer;

      &::after {
        display: block;
        content: "+";
        font-size: 21px;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: -6px;
        margin-left: -3px;
      }

      &--active::after {
        content: "-";
        font-size: 21px;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: -8px;
        display: block;
        margin-left: 0px;
      }
    }

    &__title {
      flex-grow: 2;
      max-width: 40vw;

      &.disabled {
        color: #939393 !important;
      }
    }

    &__gap {
      flex-grow: 1;
    }
  }

  &__body {
    overflow: hidden;
    max-height: 0;
    transition: 0.3s ease-in-out;
    padding-bottom: 0;

    &--active {
      max-height: 1000px;
      transition: max-height 0.3s ease-in-out;
    }
  }

  & &__body {
    .policy {
      padding-top: 0;
      border-top: 0;
      background-color: transparent;
      position: static;

      &__header {
        background-color: transparent;
        padding-left: 45px;
        border: none;
        position: relative;

        &:before {
          content: unset;
          display: none;
        }

        &__title {
          max-width: calc(40vw - 100px);
          margin-left: 6px;
          border-bottom: 2px solid #d8dfe2;
          padding-bottom: 10px;

          &:before {
            content: "";
            background-color: #d8dfe3;
            position: absolute;
            display: block;
            width: 55px;
            height: 2px;
            left: 28px;
            margin-top: -11px;
          }
        }

        &__arrow {
          height: 16px;
          margin-left: 48px;
        }

        &:after {
          content: "";
          width: auto;
          left: 47px;
          top: 30px;
          font-size: 13px;
          color: #b7c6cd;
          position: absolute;
        }

        &__statistics__box {
          &:before,
          &:after {
            content: unset;
            display: none;
          }
        }
      }

      &__body {
        padding-left: 160px;
        position: relative;
        margin-top: -14px;

        &__row {
          padding: 9px 16px;
          border-left: solid #d8dfe3;
          display: flex;
          align-items: center;
          position: relative;

          &__info {
            color: #4c8dbb;
            font-size: 18px;
            max-width: calc(40vw - 42px);
            display: flex;
            align-items: center;
            flex-grow: 1;
            padding-right: 16px;
            padding-left: 35px;
            position: relative;

            span {
              cursor: pointer;
              font: normal normal normal 16px/22px Open Sans;
              letter-spacing: 0px;
              color: #4c8dbb;
            }

            .pointer {
              cursor: pointer;
            }

            & span {
              flex-grow: 1;
              margin-left: 12px;

              &:before {
                content: "";
                background-color: #d8dfe3;
                position: absolute;
                display: block;
                width: 55px;
                height: 2px;
                left: -16px;
                margin-top: 10px;
              }
            }

            &__overview,
            &__policy {
              padding: 0 15px;
              border: solid rgba(112, 112, 112, 0.27);
              text-align: center;
              font-size: 15px;
            }

            &__overview {
              border-width: 0 0 0 1px;
              padding-right: 0;
              font-style: normal;
            }

            &__policy {
              font-style: normal;
              border-width: 0 0 0 1px;
            }
          }
          &__statistics {
            font-size: 22px;
            width: 115px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #4c8dbb;
            z-index: 999;
          }
        }
      }
    }
  }
}
</style>
  